module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1143190010/src/~/core-js/library/modules/_add-to-unscopables.js
// module id = cq/B
// module chunks = 6